export const LoadTwitter = () => {
    (function(e,t,n,s,u,a){
    if(e.twq)return;s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);}
    s.version='1.1';s.queue=[];u=t.createElement(n);u.async=!0;u.src='//static.ads-twitter.com/uwt.js';a=t.getElementsByTagName(n)[0];a.parentNode.insertBefore(u,a)})(window,document,'script');
    window.twq('init','o4fdo');
    window.twq('track','PageView');
};
